import { render } from "./RequestInitiativeTtrCard.vue?vue&type=template&id=80bb29c2&scoped=true"
import script from "./RequestInitiativeTtrCard.vue?vue&type=script&lang=js"
export * from "./RequestInitiativeTtrCard.vue?vue&type=script&lang=js"

import "./RequestInitiativeTtrCard.vue?vue&type=style&index=0&id=80bb29c2&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80bb29c2"]])

export default __exports__